/** This export is automatically generated */
export const isoNow = '2025-05-28T07:37:29.952Z';
